import { Alert, Button, Card, Checkbox, Form, Input } from 'antd'
import * as React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import trackerApi from 'src/component/app/tracker/TrackerApi'

const FormItem = Form.Item

const TrackerCreate = () => {

    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const navigateTo = useNavigate()

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await trackerApi.create(values)
            navigateTo('/tracker')
        } catch (e) {
            setError(e.error)
        }
    }

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card title="Tracker" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
                rules={[{ required: true, message: 'Tracker name required' }]}
            >
                <Input placeholder="Name" />
            </FormItem>
            <FormItem
                required
                name="domain"
                label="Domain"
                rules={[{ required: true, message: 'Tracker domain required' }]}
            >
                <Input placeholder="Domain" />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue="true"
            >
                <Checkbox />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Create</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/tracker')}>Cancel</Button>
        </div>
    </Form>
}

export default TrackerCreate



// WEBPACK FOOTER //
// ./src/component/app/tracker/TrackerCreate.tsx